// ─────────────────────────────────────────────────────────────────────────────
// Баркод уншигч — бүтэн дэлгэцийн камер + ZXing (EAN/UPC г.м.). Нэг амжилттай
// уншилтад `onDetected(text)` дуудаад хаагдана. Ард талын камер (environment).
//
// ⚠️ HTTPS + камерын зөвшөөрөл шаардлагатай (store.erdenet24.mn HTTPS тул OK).
// ─────────────────────────────────────────────────────────────────────────────
import React, { useEffect, useRef, useState } from "react";
import { BrowserMultiFormatReader } from "@zxing/browser";

export default function BarcodeScanner({ onDetected, onClose }) {
  const videoRef = useRef(null);
  const controlsRef = useRef(null);
  const doneRef = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const reader = new BrowserMultiFormatReader();
    let stopped = false;

    (async () => {
      try {
        const controls = await reader.decodeFromConstraints(
          { video: { facingMode: { ideal: "environment" } } },
          videoRef.current,
          (result) => {
            if (result && !doneRef.current) {
              doneRef.current = true;
              const text = result.getText();
              try { controls.stop(); } catch (e) {}
              onDetected(text);
            }
          },
        );
        controlsRef.current = controls;
        if (stopped) { try { controls.stop(); } catch (e) {} }
      } catch (e) {
        console.error("Scanner алдаа:", e);
        setError(
          e?.name === "NotAllowedError"
            ? "Камерын зөвшөөрөл олгоно уу."
            : "Камер нээж чадсангүй.",
        );
      }
    })();

    return () => {
      stopped = true;
      try { controlsRef.current?.stop(); } catch (e) {}
    };
  }, [onDetected]);

  return (
    <div className="e24-scanner-overlay">
      <div className="e24-scanner-stage">
        <video ref={videoRef} className="e24-scanner-video" muted playsInline autoPlay />
        <div className="e24-scanner-frame" />
      </div>
      <div className="e24-scanner-hint">
        {error || "Барааны баркодыг хүрээн дотор байрлуулна уу"}
      </div>
      <button type="button" className="btn btn-light e24-scanner-close" onClick={onClose}>
        Болих
      </button>
    </div>
  );
}
